import {
  faCircleCheck,
  faCircleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { BodyM, BodyS, HeadlineXS } from 'atoms/typography';
import { Input } from 'components/form/Form/IntlTelInput';
import {
  SecurityCheckTab,
  useAccountSecurityCheckContext,
} from 'contexts/accountSecurityCheck';
import { useCurrentUserContext } from 'contexts/currentUser';
import { glossary } from 'lib/glossary';

export const PhoneNumber = () => {
  const { setSecurityCheckTab, setOnBackTarget, setUnverifiedPhoneNumber } =
    useAccountSecurityCheckContext();
  const { currentUser } = useCurrentUserContext();
  if (!currentUser) return null;

  const {
    phoneNumber,
    unverifiedPhoneNumber,
    phoneNumberVerificationRequested,
  } = currentUser;

  const addOrVerify = () => {
    if (phoneNumberVerificationRequested) {
      setSecurityCheckTab(SecurityCheckTab.VERIFY_PHONE_NUMBER);
      setOnBackTarget(SecurityCheckTab.ADD_PHONE_NUMBER);
      setUnverifiedPhoneNumber(unverifiedPhoneNumber!);
    } else {
      setSecurityCheckTab(SecurityCheckTab.ADD_PHONE_NUMBER);
    }
  };

  return (
    <Vertical gap={2}>
      <Vertical>
        <Horizontal>
          {phoneNumber ? (
            <FontAwesomeIcon
              icon={faCircleCheck}
              color="var(--c-onBase-success)"
            />
          ) : (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              color="var(--c-red-500)"
            />
          )}
          <HeadlineXS as="h6" color="var(--c-white)">
            <FormattedMessage
              id="accountSecurityCheck.phoneNumber.title"
              defaultMessage="Phone number"
            />
          </HeadlineXS>
        </Horizontal>
        {!phoneNumber && (
          <BodyS color="var(--c-nd-600)">
            <FormattedMessage
              id="accountSecurityCheck.phoneNumber.desc"
              defaultMessage="Sorare uses phone numbers for security and anti-fraud purposes. It also helps our support team verify your identity in case you’ve lost your authentication device and recovery code."
            />
          </BodyS>
        )}
      </Vertical>
      {!!currentUser.phoneNumber && (
        <Input
          defaultPhone={currentUser.phoneNumber}
          noBorder
          disabled
          hideDetails
        />
      )}
      {!phoneNumber && (
        <BodyM color="var(--c-link)">
          <button type="button" onClick={addOrVerify}>
            <FormattedMessage {...glossary.addPhoneNumber} />
          </button>
        </BodyM>
      )}
    </Vertical>
  );
};
